module.exports = __webpack_public_path__ + "public/SiteIcons/plusIncrementIcon.svg?a98681b1";